/* eslint-disable import/no-anonymous-default-export */
export default {
  common: {
    keywordSearch: "输入要搜索的关键字",
    actions: "操作",
    add: "添加",
    edit: "编辑",
    view: "查看",
    tag: "标签",
    collapseMenu: "折叠菜单",
    save: "保存",
    cancel: "取消",
    delete: "删除",
    ok: "确定",
    confirm: "确认",
    deleteConfirmMsg: "您确定要删除吗?",
    no: "不是",
    yes: "是",
    noDataAvailable: "无数据",
    pagination: {
      rowsPerPage: "每页行数：",
      range: "{{from}}–{{to}} / 共 {{total}} 条",
      page: "页码",
      pageInput: "页码",
      ofPages: "/ 共 {{total}} 页",
      firstPage: "首页",
      previousPage: "上一页",
      nextPage: "下一页",
      lastPage: "末页",
      invalidPage: "请输入 1 到 {{total}} 之间的页码",
    },
    reason: "原因",
    createdBy: "创建者",
    modifiedBy: "修改者",
    saveChanges: "保存更改",
    close: "关闭",
    pleaseEnter: "请输入...",
    globalSmartSearch: "输入搜索关键字",
    loadingText: "我们正在为你加载数据. 请稍等.",
    collapse: "折叠",
    expand: "展开",
    search: "搜索",
    paracetamol: "扑热息痛",
    clone: "复制",
    disable: "禁用",
    enable: "启用",
    clearFilter: "清除过滤项",
    downloadPDF: "PDF下载",
    downloadCSV: "CSV下载",
    downloadExcel: "Excel下载",
    ac: "管理中心",
    signOut: "登出",
    dashboard: "仪表板",
    association: "关联",
  },
  appLauncher: {
    app: {
      title: "用户中心",
      subTitle: "访问业务模块和核心功能",
    },
    tenant: {
      title: "平台",
      subTitle: "Freyr 管理员管理平台级配置",
    },
  },
  date: {
    receivedDate: "接收日期",
    dueDate: "到期日",
    responseDate: "响应日期",
    binderApprovalDate: "批准日期",
    createdDate: "创建日期",
    modifiedDate: "修改日期",
  },
  menu: {
    dashboards: "仪表盘",
    pinned: "已固定",
    recent: "最近的",
    searchModule: "搜索模块",
    freya: "Freya",
    modules: "模块",
    showMenu: "显示菜单",
    hideSideMenu: "隐藏菜单",
    showNavigationSidebar: "显示导航侧边栏",
    products: "产品",
    registration: "登记",
    applications: "应用",
    sequences: "序列",
    change_management: "变更管理",
    submissions: "意见书",
    rtqs: "RTQs",
    documents: "文档",
    insights: "洞察力",
    racs: "RACS",
    prompts: "提示",
    components: "组件",
    doc_chat: "文档聊天",
    settings: "设置",
    document_types: "文件类型",
    document_records: "文件记录",
    published_documents: "发表文件",
    platformRelatedReports: "报告",
    docsManager: "Docs Manager",
    uiManager: "UI Manager",
    archiveManager: "Archive Manager",
    planAndAutomation: "Plan & Automation",
    eventManager: "Event Manager",
    clients: "客户",
    scim: "SCIM",
  },
  scimManager: {
    title: "SCIM 配置",
    baseUrl: "SCIM Base URL",
    secretToken: "Secret Token",
    status: "状态",
    expiresAt: "过期时间",
    validUntil: "有效期至",
    neverExpires: "不过期",
    graceExpiresAt: "旧 Token 宽限截止",
    defaultGraceHours: "默认宽限（小时）",
    generate: "生成",
    rotate: "轮换",
    revoke: "吊销",
    delete: "删除",
    revokeTitle: "吊销 SCIM 凭证",
    deleteTitle: "删除 SCIM 凭证",
    copyBaseUrl: "复制 Base URL",
    copySecret: "复制 Secret Token",
    disabledMessage: "此租户未启用 SCIM。请联系平台管理员。",
    secretOnceWarning: "该密钥仅显示一次。请立即复制并安全保存，离开后无法再次查看。",
    generateTitle: "生成 SCIM 凭证",
    rotateTitle: "轮换 SCIM 凭证",
    revokeConfirm: "确认吊销该 SCIM 凭证？使用该 Token 的请求将立即失败。",
    deleteConfirm: "确认从列表中删除该 SCIM 凭证？此操作不可撤销。",
    expiresInDays: "Token 过期时间",
    gracePeriodHours: "旧 Token 宽限（小时）",
    tokenExpiresIn: "Token 有效时长",
    newTokenExpiresIn: "新 Token 有效时长",
    previousTokenValidFor: "旧 Token 继续有效（小时）",
    tokenExpirationTooltip: "设置本次生成的 Token 可使用多久；选择“不过期”则不设置日历过期时间。",
    newTokenExpirationTooltip: "设置本次轮换生成的新 Token 可使用多久。",
    previousTokenGraceTooltip: "设置被轮换的旧 Token 还能继续使用多久；选择 0 将立即吊销旧 Token。",
    secretGenerated: "SCIM 凭证已生成。",
    secretRotated: "SCIM 凭证已轮换。",
    revoked: "SCIM 凭证已吊销。",
    deleted: "SCIM 凭证已删除。",
    baseUrlCopied: "SCIM Base URL 已复制。",
    secretCopied: "Secret Token 已复制。",
    close: "关闭",
    credentialsList: "凭证列表",
    credentialsTimeHint: "时间按你的区域设置（本地时区）显示。",
    noCredentials: "暂无凭证，请先生成 Token。",
    rotatedAt: "轮换时间",
    statusActive: "当前",
    statusGrace: "上一枚（仍可用）",
    statusExpired: "已过期",
    statusRevoked: "已吊销",
    graceBanner:
      "上一枚 Token(s) 在下方截止时间之前仍可使用。请在此之前更新 IdP 中的 Secret Token。",
    remainingInDays: "{{count}} 天后",
    remainingInHours: "{{count}} 小时后",
    remainingSoon: "不到 1 小时",
    remainingPast: "已结束",
    quotaWarning:
      "User quota is {{used}} of {{quota}} used. New SCIM users will fail once the limit is reached. Updates to existing users will continue.",
    quotaReachedBody:
      "SCIM will not create new users. Updates to existing users can still succeed.",
  },
  domain: {
    label: "领域",
    pluralLabel: "领域",
    MPR: "药品",
    MDV: "医疗器械",
    COS: "消费品",
    FDS: "食物和补充剂",
    CSRA: "化学安全和法规事务",
  },
  tool: {
    summarizer: "摘录者",
    translator: "翻译家",
  },
  aiAssistant: {
    title: "很快就会来了!",
    description: "我们的人工智能助手Freya将提供更智能、更直观的用户体验。",
    subTitle: '敬请期待即将发布的版本。感谢您的耐心等待!',
    placeholder: "在这里键入询问Freya。",
  },
  product: {
    products: "产品",
    addProduct: "添加产品",
    productName: "产品名称",
    productType: "产品类型",
    productNameTooltip: "产品的名字",
    productTypeTooltip: "产品的类型",
    productFamilyCodeTooltip: "产品代码: OG-xxxx",
    productFamilyCode: "产品代码",
    activeIngredientSubstance: "活性成分/物质",
    strength: "浓度",
    strengthUnit: "浓度单位",
    dosageForm: "剂型",
    basicInformation: "基础信息",
    tradeName: "商标名称",
    // storageCondition: "存储条件",
    genericNameOrFamilyName: "通用名/系列名",
    productStatus: "产品状态",
    therapeuticArea: "治疗领域",
    countryGroup: "国家分组",
    country: "国家",
    pack: "包装",
    shelfLife: "货架期",
    storageCondition: "储存条件",
    category: "产品类别",
    type: "产品类型",
    subcategory: "产品子类别",
    name: "产品名称",
    birthdate: "国际生产日期",
    businessunit: "业务部门",
    studyNumber: "研究编号",
    studyDescription: "研究描述",
    studyApprovalDate: "研究批准日期",
  },
  rtq: {
    addRtq: "添加RTQ",
    title: "标题",
    category: "分类",
    healthAuthority: "卫生局",
    query: {
      label: "问题",
      pluralLabel: "问题",
      queryStatus: "问题状态",
      queryTopicTitle: "查询主题/标题",
    },
    tab: {
      basicInformation: "基础信息",
      basicInformationDes: "提供产品基本信息",
      questionResponseDetails: "问题和回答细节",
      questionResponseDetailsDes: "问题及回答细节",
      products: "产品",
      productsDes: "产品信息",
      submissions: "提交",
      submissionsDes: "提交信息",
      categories: "类别",
      categoriesDes: "选择适用的类别",
      documents: "文档",
      documentsDes: "上传与查询相关的文档",
      workflow: "工作流",
      workflowDes: "参见工作流和查询状态",
    },
    submission: {
      label: "提交",
      pluralLabel: "意见书",
      submissionType: "提交类型",
      procedureType: "程序类型",
      applicationNumber: "申请编号",
      mANumber: "MA 数量",
      controlNumber: "控制号",
      comments: "评论",
    },
    question: {
      addQuestion: "添加问题",
      questionDescription: "问题描述",
      questionStatus: "问题状态",
      assignedTo: "分配给",
      comments: "评论",
    },
    response: {
      addResponse: "添加响应",
      editResponse: "编辑响应",
      responseDescription: "响应描述",
      department: "部门",
      responseStatus: "响应状态",
    },
    mentionsText: "在这里提到行动日期，并分配RTQ所有者",
    owner: "所有者",
  },
  components: {
    components: "组件",
    addComponent: "新增组件",
    editKeyIdentifiers: "编辑关键词",
    content: "内容",
    contents: "内容",
    component: "组件",
    newVersion: "新版本"
  },
  filter: {
    apply: "应用",
    and: "至",
    clear: "清除",
    searchIntro: "你可以选择或反选来过滤内容.",
    selected: "已选择",
    more: "更多",
    identifiers: "过滤项",
    product: {
      label: "产品名称",
      totalLabel: "全部产品",
      searchPlaceholder: "检索产品",
    },
    markets: {
      label: "市场",
      totalLabel: "全部市场",
      searchPlaceholder: "检索市场",
    },
    country: {
      label: "国家",
      totalLabel: "全部国家",
      searchPlaceholder: "检索国家",
    },
    function: {
      label: "功能",
      totalLabel: "全部功能",
      searchPlaceholder: "检索功能",
    },
    rtq_date: {
      label: "日期",
      fromDatePlaceholder: "选择起始日期",
      toDatePlaceholder: "选择截止日期",
      lessThanPlaceholder: "选择最大日期",
      moreThanPlaceholder: "选择最小日期",
      lessThan: "日期小于",
      moreThan: "日期大于",
      between: "日期范围",
    },
    active_substance: {
      label: "活性物质",
      totalLabel: "全部活性物质",
      searchPlaceholder: "检索活性物质",
    },
    registration_no: {
      label: "注册号",
      totalLabel: "全部注册号",
      searchPlaceholder: "检索注册号",
    },
    device_id: {
      label: "设备号",
      totalLabel: "全部设备号",
      searchPlaceholder: "检索设备号",
    },
    device_name: {
      label: "设备名称",
      totalLabel: "全部设备名称",
      searchPlaceholder: "检索设备名称",
    },
    device_type: {
      label: "设备类型",
      totalLabel: "全部设备类型",
      searchPlaceholder: "检索设备类型",
    },
    document_type: {
      label: "文档定义",
      totalLabel: "全部文档定义",
      searchPlaceholder: "检索文档定义",
    },
    document_record: {
      label: "文档记录",
      totalLabel: "全部文档记录",
      searchPlaceholder: "检索文档记录",
    },
    document: {
      label: "文档",
      totalLabel: "全部文档",
      searchPlaceholder: "检索文档",
    },
    filterItems: {
      label: "过滤项",
      totalLabel: "全部过滤项",
      searchPlaceholder: "检索过滤项",
    },
  },
  userManager: {
    setAsPrimary: "设为主要",
    reassignPrimaryTenant: "重新分配主租户",
    onlyAssociatedUsersCanBeSetAsPrimary: "只有关联的用户才能被设置为主要用户。",
    pleaseDeselectPrimaryUsersAndRetry: "请取消选择当前选中的主要用户并重试。",
    someSelectedUsersAreInactiveOrArchived: "一些选中的用户处于非活动状态或已归档，无法设置为主要用户。",
    pleaseDeselectInactiveAndArchivedUsersAndTryAgain: "请取消选择非活动和已归档的用户并重试。",
    userQuotaReached:
      "The maximum number of users is {{quota}}. If you need to add more users, please contact the Freya Fusion Support Team.",
    userQuotaChipUsed: "{{used}} of {{quota}} used",
    userQuotaRemaining: "{{remaining}} remaining",
    userQuotaReachedLabel: "Quota reached",
    userQuotaTooltipStats: "{{used}} used of {{quota}} · {{remaining}} remaining",
    userQuotaTooltipStatsReached: "{{used}} used of {{quota}} · Quota reached",
    userQuotaIncludedLabel: "Included",
    userQuotaIncludedRule:
      "In-Draft, Active, Inactive (including Locked), and associated users",
    userQuotaExcludedLabel: "Excluded",
    userQuotaExcludedRule: "Deleted and Archived",
    userQuotaImportNotImported:
      "The entire file was not imported. No users were created and no existing users were updated.",
    userQuotaImportRemaining: "{{remaining}} user quota remaining",
    userQuotaImportNewUsers: "{{count}} new users in this file",
    userQuotaImportUpdates: "{{count}} updates not applied",
    userQuotaImportDownloadDetails: "Download details ({{count}} new users)",
    userQuotaAssociateNoneAssociated:
      "None of the selected users were associated. Remaining quota is {{remaining}}; {{selected}} users were selected.",
    tip: {
      setPrimarySuccess: "主要用户设置成功。",
    },
    user: {
      loginGroup: "登录组",
      authenticationMechanism: "认证机制",
      mfaConfig: "MFA配置",
      mfaConfigTip: "MFA配置仅适用于SSO认证方式的用户。对于登录密码认证方式的用户，其现有的MFA配置不会被修改。",
      loginGroupConfirm: "登录组一旦保存后无法更改。\n您确定要使用选定的登录组继续吗？",
    }
  },
  clientManager: {
    client: "客户",
    addClient: "新增客户",
    clientInformation: "客户信息",
    clientName: "客户名称",
    clientNameHint:
      "Names are limited to 128 characters or fewer. Names may only contain alphanumeric characters, spaces, and the following special characters: + = , . @ -",
    clientId: "客户ID",
    clientSecret: "Client Secret",
    host: "Host",
    scope: "Scope",
    addExampleCodeTitle: "Add the example code to your application",
    getAccessTokenDescription: "Get an access token with a custom scope.",
    showClientSecret: "Show client secret",
    hideClientSecret: "Hide client secret",
    copyClientSecret: "Copy Client Secret",
    copyClientId: "Copy Client ID",
    copyHost: "复制 Host",
    copyScope: "复制 Scope",
    copyConnectionInfo: "复制连接信息",
    copyExampleCode: "复制示例代码",
    roles: "角色",
    role: "角色",
    addRole: "新增角色",
    removeRole: "移除角色",
    deleteClient: "The selected client will be deleted. Do you wish to proceed?",
    deleteClientWithDependency:
      "Are you sure you want to delete this client as it has dependencies?",
    clientQuotaReached:
      "The maximum number of clients is {{quota}}. If you need to add more clients, please contact the Freya Fusion Support Team.",
    tip: {
      addSuccess: "客户创建成功。",
      updateSuccess: "客户更新成功。",
      addRoleSuccess: "角色添加成功。",
      removeRoleSuccess: "角色移除成功。",
      deleteSuccess: "Client has been deleted successfully.",
      clientSecretCopied: "Client Secret copied to clipboard.",
      clientSecretCopyFailed: "Unable to copy Client Secret.",
      clientSecretQueryFailed: "Unable to retrieve the Client Secret. Please try again.",
      clientIdCopied: "Client ID copied to clipboard.",
      clientIdCopyFailed: "Unable to copy Client ID.",
      hostCopied: "Host 已复制到剪贴板。",
      hostCopyFailed: "无法复制 Host。",
      scopeCopied: "Scope 已复制到剪贴板。",
      scopeCopyFailed: "无法复制 Scope。",
      connectionInfoCopied: "连接信息已复制到剪贴板。",
      connectionInfoCopyFailed: "无法复制连接信息。",
    },
    verify: {
      clientName: "客户名称为必填项",
      clientNameFormat:
        "Names are limited to 128 characters or fewer. Names may only contain alphanumeric characters, spaces, and the following special characters: + = , . @ -",
      clientId: "客户ID为必填项",
    },
  },
  audit: {
    label: "Audit Reports",
    filter: {
      startDate: "Start Date",
      endDate: "End Date",
      startDateTime: "开始日期时间",
      endDateTime: "结束日期时间",
      operationType: "Operation Type",
    },
    grid: {
      auditIdentifier: "Audit Identifier",
      operationType: "Operation Type",
      operatorUsername: "User",
      operationDate: "Operation Date and Time",
      entityIdentifier: "Record Id",
      entityName: "Entity Name",
      reason: "Reason",
      notes: "Note: This table only contains the fields which were updated during this transaction"
    },
    compareAudit: "审计对比",
    truncateFileTip: " ... Content truncated due to size limit. Displaying {{maxLines}} of {{totalLines}} total lines."
  },
  report: {
    module: "模块",
    reportType: "报告类型",
    reportName: "报告名称",
  },
  gridManager: {
    group: "Group",
  },
  formManager: {
    groupWizard: "Group/Wizard",
    groupWizardDisplayName: "Group/Wizard Display Name",
    groupDisplayName: "Group Display Name",
  },
  wizardManager: {
    wizardDisplayName: "Wizard Display Name",
  },
  userGroupManager: {
    noOptions: "没有可用选项",
    noDataAvailable: "暂无数据",
    noResultsFound: "没有找到结果。",
    tip: {
      dimensionsSaved: "维度保存成功。",
    },
  },
  menuManager: {
    goToFieldList: "前往字段列表",
    group: "Group",
    groupDisplayName: "Group Display Name",
    requiresGenerateGridEnabled: "需要先启用「生成网格」。",
    goToMenuList: "Go to Menu List",
    objectName: "Object Name",
    objectDisplayName: "Object Display Name",
    objectMainGridConfig: "Object Main Grid Config",
    objectMainGridSourceFormat:
      "Form Name · Type · Module > Object > Group(Wizard)",
    setupObjectMainGrid: "Configure Object Main Grid",
    mainGridName: "Main Grid Name",
    mainGridConfigurationTitle: "Main Grid Configuration",
    mainGridConfigurationDescription:
      "Define grid hierarchy nodes, assign a source per node, and choose visible columns.",
    switchObjectUnsavedWarning:
      "Switching the object will discard unsaved changes. Continue?",
    switchObjectStay: "Stay",
    loadConfigFailed:
      "Failed to load Object Main Grid configuration. Please try again.",
    objectHeaderBadgeConfig: "Object Header Badge Config",
    setupObjectHeaderBadge: "Setup Object Header Badge",
    addObjectHeaderBadgeRule: "Add Rule",
    objectHeaderBadgeSourceHint:
      "Form Name · Type · Module > Object > Group(Step)",
    objectHeaderBadgeSourceSearchPlaceholder: "Search by Form/Grid name",
    loadObjectHeaderBadgeFailed:
      "Failed to load Object Header Badge configuration. Please try again.",
  },
};
